import React from 'react';
import './PageHeader.css';

export default class PageHeader extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className='col s4 m4 l4'>
        <h5 className='HeaderTitle'><b><span className='BlueText'>{this.props.Spotlight}</span></b> {this.props.Title}</h5>
        {this.props.Description}
      </div>
    );
  }
};

